import { getCookie } from 'cookies-next/client'
import { COOKIE_ONETRUST_CONSENT } from './config'

// OneTrust/CookiePro consent groups.
export enum ConsentGroup {
  NECESSARY = 'C0001',
  ANALYTICS = 'C0002',
  PREFERENCES = 'C0003',
  MARKETING = 'C0004',
}

export const consentedTo = (group: ConsentGroup): boolean => {
  if (group === ConsentGroup.NECESSARY || process.env.NODE_ENV !== 'production') {
    return true
  }

  // At first, for performance reasons, try to extract info out of Onetrust lib.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof (window as any)?.OnetrustActiveGroups === 'string') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (window as any)?.OnetrustActiveGroups?.includes(group)
  }

  const oneTrustConsent = getCookie(COOKIE_ONETRUST_CONSENT)

  if (!oneTrustConsent) {
    return false
  }

  const params = new URLSearchParams(oneTrustConsent)
  const groups = params.get('groups')

  if (!groups) {
    return false
  }

  return groups.split(',').some((g) => g === `${group}:1`)
}
